import { FC } from "react";

import { IButtonAction } from "config";
import { IModalProps } from "config/init/providers/ModalsProvider";
import { useButtonAction } from "containers/DynamicForm/useButtonAction";
import { Layout, useJourney, useTranslation } from "modules";

const ExitTriviaWarningModal: FC<IModalProps> = ({ closeModal, data }) => {
  const { t } = useTranslation();
  const { exitJourney } = useJourney();
  const dynamicFormButtonItemActions = (data?.actions || []) as IButtonAction[];
  const executeButtonItemActions = useButtonAction(dynamicFormButtonItemActions, true);

  const handleExitFlow = () => {
    exitJourney();
    executeButtonItemActions();

    closeModalWrapper();
  };

  const closeModalWrapper = () => {
    closeModal();
  };

  const content = {
    dataTestId: "exit-trivia-warning__modal",
    header: t(
      "fulfillment.underwriting_trivia.exit_modal.title",
      "Hang Tight - We’re Finalizing Your Rate"
    ),
    subheader: t(
      "fulfillment.underwriting_trivia.exit_modal.body",
      "Need to go? No problem. We’ll email your quote as soon as it’s ready."
    ),
    button: [
      {
        text: t("fulfillment.underwriting_trivia.exit_modal.primary", "EXIT"),
        onClick: handleExitFlow,
        dataTestId: "journey-exit-modal__confirm",
      },
      {
        text: t("fulfillment.underwriting_trivia.exit_modal.secondary", "CANCEL"),
        subType: "text-dark",
        onClick: closeModalWrapper,
        dataTestId: "journey-exit-modal__decline",
      },
    ],
    onClose: closeModalWrapper,
    icon: "BlobDocument",
  };

  return <Layout as="ModalLayout" content={content} />;
};

export default ExitTriviaWarningModal;
